import { createHOC } from 'vue-hoc';
import omit from 'lodash/omit';

import userPrefs from '../providers/userPrefs';

export default function withUserPrefs() {
  return (Component) => {
    const options = {
      name: Component.name + '-with-user-prefs',
    };

    const renderWith = {
      props: {
        getUserPref() {
            return (key) => userPrefs.get(key);
        },
        setUserPref() {
            return (key, value) => userPrefs.set(key, value);
        },
      },
    };

    const AugmentedComponent = createHOC(Component, options, renderWith);
    AugmentedComponent.props = omit(AugmentedComponent.props, 'getUserPref', 'setUserPref');
    return AugmentedComponent;
  };
}
